import { CreationOutlineIcon } from './CreationOutlineIcon';

/**
 * author: Jeff Anders
 * id E643EA62-6140-491A-9B2D-DE88F51BD37A
 * name creation-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/creation-outline.svg
 * tags
 */
export const StarsOutlineIcon = CreationOutlineIcon;
export default StarsOutlineIcon